import React from 'react';

import UserPresenter from '../../../../../../presenters/UserPresenter';
import appRoutes from '../../../../../../routes/appRoutes';
import Group from '../../../../../../components/Group';
import Row from '../../../../../../components/Row';
import Value from '../../../../../../components/Value';

import InvitedUser from './components/InvitedUser';

const ReferralInfo = (props) => {
  const { user } = props;
  const referrer = UserPresenter.referrer(user);
  const hasReferrer = UserPresenter.hasReferrer(user);
  const referrerAuth0Id = UserPresenter.auth0Id(referrer);
  const invitedUsers = UserPresenter.invitedUsers(user);
  const hasInvitedUsers = UserPresenter.hasInvitedUsers(user);

  return (
    <Group title="Referral Info">
      <Row>
        <Value attr="referrerId" title="Referred By">
          {hasReferrer && (
            <a
              href={appRoutes.userFastCashPath({ byAuth0Id: referrerAuth0Id })}
              target="_blank"
            >
              {UserPresenter.fullName(referrer)}
            </a>
          )}
          {!hasReferrer && '-'}
        </Value>
      </Row>
      <Row>
        <Value attr="invitedUsers" title="Invited Users">
          {hasInvitedUsers &&
            invitedUsers.map((user) => (
              <InvitedUser key={UserPresenter.auth0Id(user)} user={user} />
            ))}
          {!hasInvitedUsers && '-'}
        </Value>
      </Row>
    </Group>
  );
};

export default ReferralInfo;

ReferralInfo.propTypes = {
  user: UserPresenter.shape().isRequired,
};
